export const DOMAIN_PROPS_KEYS = {
  ALLOW_LIVE_RESIZE: 'allow_live_resize',
  ALLOW_LIVE_RESIZE_MIGRATION: 'allow_live_resize_migration',
  ALLOW_COMPUTE_BACKUP: 'HciComputeBackupEnabled',
  TELEMETRY: 'telemetry',
  TOTP_SETTINGS: 'totp_settings'
};

export const DOMAIN_PROPS_ACCESS_TYPES = {
  PUBLIC: 'pub',
  AUTH: 'auth'
};
